import { render, staticRenderFns } from "./XmTable.vue?vue&type=template&id=0f28a651&scoped=true"
import script from "./XmTable.vue?vue&type=script&lang=js"
export * from "./XmTable.vue?vue&type=script&lang=js"
import style0 from "./XmTable.vue?vue&type=style&index=0&id=0f28a651&prod&lang=css"
import style1 from "./XmTable.vue?vue&type=style&index=1&id=0f28a651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28a651",
  null
  
)

export default component.exports